import React, {
  useCallback,
  useContext,
  useEffect,
  useState,
  useMemo,
  useRef,
} from "react";
import { useHistory } from "react-router-dom";
import { Select, SelectOption, Image, Link, Flex } from "uikit-react";
import UIkit from "uikit";
import moment from "moment";
import classnames from "classnames";

import { AppContexts } from "../../providers/";
import { useCookies } from "react-cookie";
import FeatherIcon from "../common/FeatherIcon";

const searchValue = {
  search_term: "",
  filters: "all",
  preset: "soon",
  start_date: "2000-01-01",
  end_date: "2050-12-31",
  end_type: "check_in",
  checked_in: false,
  checked_out: false,
  categories: "",
  type: "message",
};

export default ({ onNewMessage } = {}) => {
  const inboxContext = useContext(AppContexts.InboxContext);
  const { listReservations, searchReservation } = useContext(
    AppContexts.ReservationsContext,
  );

  const { user } = useContext(AppContexts.AuthContext);
  const { notification } = useContext(AppContexts.UtilContext);
  const { setNotes } = useContext(AppContexts.NotesContext);
  const [cookies] = useCookies(["records-per-page"]);
  const { "records-per-page": recordsPerPage = 20 } = cookies;

  const [option, setOption] = useState("");
  const [search, setSearch] = useState("");
  const [pageNo, setPageNo] = useState(0);
  const [isFirst, setIsFirst] = useState(true);
  const [allThreads, setAllThreads] = useState([]);
  const [loadingMore, setLoadingMore] = useState(false);
  const scrollContainerRef = useRef(null);
  const prevPageRef = useRef(0);
  const {
    inbox,
    selectedThreadId,
    setSelectedThreadId,

    selectThread,
    selectPaginatedThread,
    selectPersonalPaginatedThread,
    getThreadDetail,
    getPaginatedThreadDetail,
    getPersonalPaginatedThreadDetail,
    setThreadDetail,

    threadCnt,
    setThreadMeta,
    setReservation,

    nextThread,

    legacy,
    setLegacy,
    // currentIndexOnPage,
    // setCurrentIndexOnPage,
  } = inboxContext;
  const history = useHistory();
  // const [inboxIds, setInboxIds] = useState([]);

  // useEffect(() => {
  //   if (inbox) {
  //     setInboxIds(inbox.map((i) => i.id));
  //   }
  // }, [inbox]);

  // Reset accumulated threads when filters change
  useEffect(() => {
    setAllThreads([]);
    setPageNo(0);
    prevPageRef.current = 0;
  }, [option, recordsPerPage, legacy]);

  useEffect(() => {
    if (!!(user.user.personal_inboxes || [])[0]) {
      inboxContext.personalInbox(
        user.user.personal_inboxes[0].id,
        pageNo,
        option,
        recordsPerPage,
      );
    } else {
      inboxContext.refresh(pageNo, option, recordsPerPage);
    }
  }, [option, recordsPerPage, pageNo, legacy]);

  // Accumulate threads as pages load
  useEffect(() => {
    if (inbox && inbox.length > 0) {
      setAllThreads((prev) => {
        if (pageNo === 0 && prevPageRef.current === 0) {
          return inbox;
        }
        // Deduplicate by id
        const existingIds = new Set(prev.map((t) => t.id));
        const newThreads = inbox.filter((t) => !existingIds.has(t.id));
        return [...prev, ...newThreads];
      });
      setLoadingMore(false);
      prevPageRef.current = pageNo;
    } else if (inbox && inbox.length === 0 && pageNo === 0) {
      setAllThreads([]);
      setLoadingMore(false);
    }
  }, [inbox]);

  useEffect(() => {
    if (!!nextThread) {
      if (personalInboxId !== null) {
        selectPersonalPaginatedThread(nextThread, personalInboxId);
      } else {
        selectPaginatedThread(nextThread);
      }
    }
  }, [inbox]);

  // useDeepCompareEffect(() => {
  //   if (currentIndexOnPage > -1) {
  //     if (inboxIds[currentIndexOnPage]) {
  //       selectThread(inboxIds[currentIndexOnPage], currentIndexOnPage);
  //     }
  //   } else {
  //     setSelectedThreadId(-1);
  //     setThreadDetail({});
  //   }
  // }, [currentIndexOnPage, inboxIds]);

  useEffect(() => {
    setIsFirst(false);
  }, []);

  const hasMore = allThreads.length < threadCnt;

  const handleScroll = useCallback(() => {
    const container = scrollContainerRef.current;
    if (!container || loadingMore || !hasMore) return;
    const { scrollTop, scrollHeight, clientHeight } = container;
    if (scrollHeight - scrollTop - clientHeight < 150) {
      setLoadingMore(true);
      setPageNo((prev) => prev + 1);
    }
  }, [loadingMore, hasMore]);

  useEffect(() => {
    const container = scrollContainerRef.current;
    if (!container) return;
    container.addEventListener("scroll", handleScroll);
    return () => container.removeEventListener("scroll", handleScroll);
  }, [handleScroll]);

  const personalInboxId = useMemo(() => {
    if (!!(user.user.personal_inboxes || [])[0]) {
      return user.user.personal_inboxes[0].id;
    }

    return null;
  }, [user]);

  const toggleLegacy = () => {
    setLegacy(!legacy);
  };

  const handleSelect = (threadId, index) => {
    // let current = +window.location.pathname.split("/")[2];

    if (threadId === null) {
      history.push("/messages/new");
      setSelectedThreadId("new");
      setThreadDetail({});
    } else if (+selectedThreadId !== +threadId) {
      history.push(`/messages/${threadId}`);
      if (personalInboxId !== null) {
        selectPersonalPaginatedThread(threadId, personalInboxId);
      } else {
        selectPaginatedThread(threadId);
      }
      // setCurrentIndexOnPage(index);
    }

    // pushToRoom("update_status", {
    //   thread_id: threadId,
    //   personal_inbox_id: personalInboxId,
    //   status: "viewing",
    // });

    setNotes([]);
  };

  const handleSelectOption = (e) => {
    setOption(e.target.value);
  };

  const reservations = useMemo(() => {
    let sorts = listReservations?.sort((prev, next) => {
      return next.check_in?.localeCompare(prev.check_in);
    });
    let buf = [];
    sorts.forEach((sort) => {
      if (sort.thread_id === null) {
        buf.push(sort);
      } else {
        if (!buf.find((item) => item?.thread_id === sort.thread_id)) {
          buf.push(sort);
        }
      }
    });
    return buf;
  }, [listReservations]);

  const handleMetaCallback = async (result, thread_id, token) => {
    if (result) {
      let message;
      let next = null;
      // console.log(result.thread);
      if (token === "unread") {
        message = !!(result.thread.meta?.tokens || []).find(
          (t) => t === "unread",
        )
          ? "Message Marked as Unread"
          : "Message Marked as Read";
      } else if (token === "priority") {
        message = !!(result.thread.meta?.tokens || []).find(
          (t) => t === "priority",
        )
          ? "Message Prioritized"
          : "Message Deprioritized";
      } else {
        next = ((inbox || []).findIndex((t) => +t.id === +thread_id) || -1) + 1;
        message = !!(result.thread.meta?.tokens || []).find(
          (t) => t === "archived",
        )
          ? "Message Archived"
          : "Message Unarchived";
      }
      UIkit.notification(message, "success");

      if (!searchValue.search_term) {
        if (personalInboxId !== null) {
          await inboxContext.personalInbox(
            personalInboxId,
            pageNo,
            option,
            recordsPerPage,
            true,
            next,
          );
        } else {
          await inboxContext.refresh(
            pageNo,
            option,
            recordsPerPage,
            true,
            next,
          );
        }
      } else {
        searchReservation(searchValue);
      }
    }
  };

  // const getSortedReservations = (guestResrvs) => {
  //   if (!guestResrvs) {
  //     return { current: [], upcoming: [], past: [] };
  //   }

  //   const current = [];
  //   const upcoming = [];
  //   const past = [];
  //   if (guestResrvs.length) {
  //     guestResrvs.forEach((it) => {
  //       let check_in = it.check_in;
  //       let check_out = it.check_out;
  //       if (check_in > moment().format("YYYY-MM-DD")) {
  //         upcoming.push(it);
  //       } else if (check_out < moment().format("YYYY-MM-DD")) {
  //         past.push(it);
  //       } else {
  //         current.push(it);
  //       }
  //     });
  //   }
  //   return { current, upcoming, past };
  // };

  useEffect(() => {
    if (search !== "") {
      searchValue.search_term = search.trim();
      searchReservation(searchValue);
    }
  }, [search]);

  useEffect(() => {
    if (!!notification) {
      if (personalInboxId !== null) {
        inboxContext.personalInbox(
          personalInboxId,
          pageNo,
          option,
          recordsPerPage,
          true,
        );
      } else {
        inboxContext.refresh(pageNo, option, recordsPerPage, true);
      }
      if (+notification.thread_id === +window.location.pathname.split("/")[2]) {
        if (personalInboxId !== null) {
          getPersonalPaginatedThreadDetail(
            notification.thread_id,
            personalInboxId,
          );
        } else {
          getPaginatedThreadDetail(notification.thread_id);
        }
      }
    }
  }, [notification]);

  const handleGuest = (e) => {
    setSearch(e.target.value);
  };

  const togglePersonalMeta = async (thread_id, token) => {
    let result = null;
    if (!!(user.user.personal_inboxes || [])[0]) {
      result = await inboxContext.togglePersonalMeta(
        thread_id,
        user.user.personal_inboxes[0].id,
        token,
      );
    } else {
      result = await inboxContext.setMeta(thread_id, {
        thread_id,
        token: token,
      });
    }

    handleMetaCallback(result, thread_id, token);
  };

  const setPersonalMeta = async (thread_id, token, set) => {
    let result = null;
    if (!!(user.user.personal_inboxes || [])[0]) {
      result = await inboxContext.setPersonalMeta(
        thread_id,
        user.user.personal_inboxes[0].id,
        token,
        set,
      );
    } else {
      result = await inboxContext.setMeta(thread_id, {
        thread_id,
        token: token,
      });
    }

    handleMetaCallback(result, thread_id, token);
  };

  const handleMeta = async (thread_id, metaType, flag) => {
    let result = null;
    if (!!(user.user.personal_inboxes || [])[0]) {
      let result = await inboxContext.setPersonalMeta(thread_id, {
        thread_id,
        token: metaType,
      });
    } else {
      let result = await inboxContext.setMeta(thread_id, {
        thread_id,
        token: metaType,
      });
    }

    if (result) {
      let message;
      let next = null;
      if (metaType === "unread") {
        message = result.thread.meta?.find((item) => item.token === "unread")
          ? "Message Marked as Unread"
          : "Message Marked as Read";
      } else if (metaType === "priority") {
        message = result.thread.meta?.find((item) => item.token === "priority")
          ? "Message Prioritized"
          : "Message Deprioritized";
      } else {
        next = ((inbox || []).findIndex((t) => +t.id === +thread_id) || -1) + 1;
        message = result.thread.meta?.find((item) => item.token === "archived")
          ? "Message Archived"
          : "Message Unarchived";
      }
      UIkit.notification(message, "success");
      flag
        ? await inboxContext.personalInbox(
            pageNo,
            option,
            recordsPerPage,
            true,
            next,
          )
        : searchReservation(searchValue);
    }
  };

  const reservationRenderer = (reservation, index) => {
    const isUnread = reservation.thread_meta?.indexOf("unread") >= 0;

    return (
      <div
        className={classnames("chat-guest-contact-wrapper", {
          "active-chat-guest-contact":
            selectedThreadId == reservation.thread_id,
          "thread-unread": isUnread,
        })}
        key={index}
        onClick={() => {
          handleSelect(reservation.thread_id);
          setReservation(reservation);
        }}
      >
        <div className="message-text-group">
          <Image src="/images/guest-active.svg" />
          <div>
            <div className="chat-guest-contact-name">
              {reservation.first_name} {reservation.last_name}
            </div>
            {/* <div className="chat-guest-contact-address">
              {reservation.pms_id}
            </div> */}
            <div className="chat-guest-contact-date">
              {reservation.last_message_on
                ? moment
                    .utc(reservation.last_message_on)
                    .local()
                    .format("MMM DD, YYYY hh:mm a")
                : "No messages yet"}
            </div>
          </div>
        </div>
        <div className="messages-btn-group">
          <button
            className={classnames("uk-button hms-simple-icon-btn", {
              "icon-active": isUnread,
            })}
            type="button"
            uk-tooltip={
              isUnread
                ? "Mark as Read"
                : "Mark as Unread"
            }
            onClick={() => {
              togglePersonalMeta(reservation.thread_id, "unread");
            }}
          >
            {isUnread ? (
              <span className="inbox-unread-dot" aria-hidden="true" />
            ) : (
              <FeatherIcon name="mail" className="inbox-action-icon" color="inherit" />
            )}
          </button>
          <button
            className={classnames("uk-button hms-simple-icon-btn", {
              "icon-active icon-priority":
                reservation.thread_meta?.indexOf("priority") >= 0,
            })}
            type="button"
            uk-tooltip={
              reservation.thread_meta?.indexOf("priority") >= 0
                ? "Unprioritize"
                : "Prioritize"
            }
            onClick={() =>
              togglePersonalMeta(reservation.thread_id, "priority")
            }
          >
            <FeatherIcon
              name="flag"
              className="inbox-action-icon"
              color="inherit"
            />
          </button>
          <button
            className={classnames("uk-button hms-simple-icon-btn", {
              "icon-active icon-archived":
                reservation.thread_meta?.indexOf("archived") >= 0,
            })}
            type="button"
            uk-tooltip={
              reservation.thread_meta?.indexOf("archived") >= 0
                ? "Unarchive"
                : "Archive"
            }
            onClick={() =>
              togglePersonalMeta(reservation.thread_id, "archived")
            }
          >
            <FeatherIcon
              name="archive"
              className="inbox-action-icon"
              color="inherit"
            />
          </button>
        </div>
      </div>
    );
  };

  const threadRenderer = (thread, index) => {
    var {
      contact_first_name,
      contact_last_name,
      guest_first_name,
      guest_last_name,
      formatted_contact_phone,
      formatted_guest_phone,
      last_msg,
    } = thread;

    var firstName =
      contact_first_name ||
      guest_first_name ||
      formatted_contact_phone ||
      formatted_guest_phone ||
      "[Unknown]";

    var lastName = contact_last_name || guest_last_name || "";
    const isUnread = thread.meta_values.indexOf("unread") >= 0;

    return (
      <div
        className={classnames("chat-guest-contact-wrapper", {
          "active-chat-guest-contact": selectedThreadId == thread.id,
          "thread-unread": isUnread,
        })}
        key={thread.id}
      >
        <div
          className="message-text-group"
          onClick={() => {
            handleSelect(thread.id, index);
          }}
        >
          <span
            className="message-text-group-icon"
            uk-tooltip={`title: ${
              thread.contact_category
                ?.toLowerCase()
                .replace(/\b\w/g, (s) => s.toUpperCase()) || "Guest"
            }; pos: bottom-left; cls: uk-active contact-tooltip`}
          >
            {thread.contact_category !== null ? (
              <Image src={`/images/${thread.contact_category}-active.svg`} />
            ) : (
              <Image src="/images/guest-active.svg" />
            )}
          </span>
          <div>
            <div className="semi-bold-font">
              {[firstName, lastName].join(" ")}
            </div>
            {thread.contact_category === null &&
              thread.current_reservation_count > 0 &&
              (thread.current_reservation_count > 1 ? (
                <div className="chat-guest-contact-address uk-margin-tiny-top uk-margin-tiny-bottom">
                  Multiple Current Bookings
                  <img
                    class="info-icon"
                    src="/images/info-icon.svg"
                    alt="info"
                    uk-tooltip={`${thread.current_reservation_count} Current Bookings. See the right side for Property IDs.`}
                    title=""
                    aria-describedby="uk-tooltip-134"
                    tabindex="0"
                  />
                </div>
              ) : (
                <div
                  className="chat-guest-contact-address uk-margin-tiny-top uk-margin-tiny-bottom"
                  uk-tooltip={thread?.unit_code}
                >
                  {thread?.unit_code.length > 30
                    ? `${thread.unit_code.slice(0, 30)}`
                    : thread?.unit_code}
                </div>
              ))}
            <div
              className={
                thread.meta_values.indexOf("unread") >= 0
                  ? "chat-guest-unread-message"
                  : "chat-guest-message"
              }
            >
              {last_msg?.length > 60 ? `${last_msg.slice(0, 60)}...` : last_msg}
            </div>
            <div className="chat-guest-handled">
              {thread.meta_values.indexOf("unhandled") === -1 && (
                <span aria-label="Handled" uk-tooltip="Handled">
                  <FeatherIcon
                    name="check"
                    className="handled-icon"
                    color="#28a745"
                  />
                </span>
              )}
            </div>
            <div className="chat-guest-contact-date">
              {moment
                .utc(thread.last_message_on)
                .local()
                .format("MMM DD, YYYY hh:mm a")}
            </div>
          </div>
        </div>
        <div className="messages-btn-group">
          <button
            className={classnames("uk-button hms-simple-icon-btn", {
              "icon-active": isUnread,
            })}
            uk-tooltip={
              isUnread
                ? "Mark as Read"
                : "Mark as Unread"
            }
            onClick={() => togglePersonalMeta(thread.id, "unread")}
          >
            {isUnread ? (
              <span className="inbox-unread-dot" aria-hidden="true" />
            ) : (
              <FeatherIcon name="mail" className="inbox-action-icon" color="inherit" />
            )}
          </button>
          <button
            className={classnames("uk-button hms-simple-icon-btn", {
              "icon-active icon-priority":
                thread.meta_values.indexOf("priority") >= 0,
            })}
            onClick={() => togglePersonalMeta(thread.id, "priority", true)}
            uk-tooltip={
              thread.meta_values.indexOf("priority") >= 0
                ? "Unprioritize"
                : "Prioritize"
            }
          >
            <FeatherIcon
              name="flag"
              className="inbox-action-icon"
              color="inherit"
            />
          </button>
          <button
            className={classnames("uk-button hms-simple-icon-btn", {
              "icon-active icon-archived":
                thread.meta_values.indexOf("archived") >= 0,
            })}
            onClick={() => togglePersonalMeta(thread.id, "archived")}
            uk-tooltip={
              thread.meta_values.indexOf("archived") >= 0
                ? "Unarchive"
                : "Archive"
            }
          >
            <FeatherIcon
              name="archive"
              className="inbox-action-icon"
              color="inherit"
            />
          </button>
        </div>
      </div>
    );
  };

  return (
    <aside
      className="uk-card uk-card-default uk-card-small uk-card-body uk-width-1-4@m hms-msg-cards chat-guest-contact-card"
      style={{ display: "flex", flexDirection: "column", overflow: "hidden" }}
    >
      {!+user?.user?.owner_id && (
        <div className="inboxSelector">
          <button
            className={`uk-button hms-btn hms-blue-btn ${legacy ? "hms-blue-btn-transparent" : ""}`}
            onClick={toggleLegacy}
          >
            My Inbox
          </button>
          <button
            className={`uk-button hms-btn hms-blue-btn ${!legacy ? "hms-blue-btn-transparent" : ""}`}
            onClick={toggleLegacy}
          >
            All Messages
          </button>
        </div>
      )}
      <div className="chat-msg-type">
        <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
          <Select onChange={handleSelectOption}>
            <SelectOption value="">Inbox</SelectOption>
            <SelectOption value="priority">Priority</SelectOption>
            <SelectOption value="unread">Unread</SelectOption>
            <SelectOption value="archived">Archived</SelectOption>
            <SelectOption value="all">All Messages</SelectOption>
          </Select>
          {onNewMessage && (
            <span
              style={{
                cursor: "pointer",
                display: "inline-flex",
                alignItems: "center",
              }}
              onClick={onNewMessage}
              uk-tooltip="New Message"
            >
              <FeatherIcon name="plus-circle" className="inbox-new-msg-icon" />
            </span>
          )}
        </div>
        <div className="uk-search uk-search-default">
          {!search ? (
            <span className="uk-search-icon-flip" uk-search-icon="true"></span>
          ) : (
            <span
              className="uk-close-icon uk-close-icon-flip"
              uk-icon="close"
              onClick={() => {
                handleGuest({ target: { value: "" } });
              }}
            ></span>
          )}
          <input
            className="uk-search-input"
            type="search"
            placeholder="Guest Name Or Property ID"
            value={search}
            onChange={handleGuest}
          />
        </div>
      </div>
      <div
        style={{
          flex: 1,
          minHeight: 0,
          display: "flex",
          flexDirection: "column",
        }}
      >
        <div
          className="chat-guest-contact"
          ref={scrollContainerRef}
          style={{ flex: 1, minHeight: 0, overflowY: "auto" }}
        >
          {search === "" ? (
            allThreads.length === 0 && !loadingMore ? (
              <div className="uk-margin-top">
                There are no messages in this folder
              </div>
            ) : (
              <>
                {allThreads.map((thread, index) =>
                  threadRenderer(thread, index),
                )}
                {loadingMore && (
                  <div className="uk-text-center uk-margin-small">
                    <div uk-spinner="ratio: 0.8"></div>
                  </div>
                )}
              </>
            )
          ) : reservations?.length === 0 ? (
            <div className="uk-margin-top">
              There are no messages in this folder
            </div>
          ) : (
            reservations?.map((reservation, index) =>
              reservationRenderer(reservation, index),
            )
          )}
        </div>
      </div>
    </aside>
  );
};
